import { t } from '@lingui/core/macro';
import { AccordionItem, AccordionItemElement, Box, Tooltip, formatPhoneNumber } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { useUnsupportedRecipientValues } from 'app/domains/esigning/hooks/useUnsupportedRecipientValues';
import { getAuthenticationModeLabel } from 'app/domains/esigning/utils';
import { EsigningProviderAuthenticationModeSlug, EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { RecipientStatusBadge } from './RecipientStatusBadge';
import { StyledIconButton } from './styled';
export function RecipientItem(props) {
    const { recipient, endElement, groupMessage } = props;
    const { email, name, label, title, authenticationMode, mobile, message, status, type } = recipient;
    const { isAuthenticationModeUnsupported, isNameFormatUnsupported } = useUnsupportedRecipientValues();
    const isSigning = type === EsigningRecipientType.Signatory;
    const hasInvalidValues = isAuthenticationModeUnsupported(recipient) || isNameFormatUnsupported(recipient);
    const showMobile = authenticationMode === EsigningProviderAuthenticationModeSlug.SmsOtp && mobile;
    const personalMessageElement = (<Tooltip title={t({
            comment: 'Tooltip for signing party with a personal message added',
            message: 'Personal message added',
        })}>
      <StyledIconButton $round $appearance="info" size="xs" appearance="ghost">
        <Falcon icon="message-lines"/>
      </StyledIconButton>
    </Tooltip>);
    const invalidValuesElement = (<Tooltip title={t({
            comment: 'Tooltip for eSigning party with invalid values',
            message: 'This party has invalid fields that needs to be updated',
        })}>
      <StyledIconButton $round $appearance="error" size="xs" appearance="ghost">
        <Falcon icon="warning"/>
      </StyledIconButton>
    </Tooltip>);
    return (<AccordionItem value={recipient.id} title={name} subtitle={email} endElement={<Box alignItems="center" gap="xs">
          {status && <RecipientStatusBadge status={status}/>}
          {hasInvalidValues && invalidValuesElement}
          {message && personalMessageElement}
          {endElement}
        </Box>}>
      <AccordionItemElement reverseTexts icon={<Falcon icon="envelope"/>} title={email} subtitle={t({ comment: 'E-signing party email label', message: 'Email' })}/>
      {title && (<AccordionItemElement reverseTexts icon={<Falcon icon="briefcase"/>} title={title} subtitle={t({ comment: 'E-signing party title label', message: 'Title' })}/>)}
      {showMobile && (<AccordionItemElement reverseTexts icon={<Falcon icon="phone"/>} title={formatPhoneNumber(mobile)} subtitle={t({ comment: 'E-signing party phone label', message: 'Phone' })}/>)}
      {label && (<AccordionItemElement reverseTexts icon={<Falcon icon="building"/>} title={label} subtitle={t({ comment: 'E-signing party company label', message: 'Company' })}/>)}
      {isSigning && (<AccordionItemElement reverseTexts icon={<Falcon icon="fingerprint"/>} title={getAuthenticationModeLabel(authenticationMode)} subtitle={t({
                comment: 'E-signing party signing method label',
                message: 'Signing method',
            })}/>)}
      {message && (<AccordionItemElement reverseTexts icon={<Falcon icon="message-lines"/>} title={message} subtitle={t({
                comment: 'E-signing party personal message label',
                message: 'Personal message',
            })}/>)}
      {groupMessage && (<AccordionItemElement reverseTexts icon={<Falcon icon="messages"/>} title={groupMessage} subtitle={t({ comment: 'E-signing party group message label', message: 'Group message' })}/>)}
    </AccordionItem>);
}
